// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { toast } from 'react-toastify';
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  signOut
} from "firebase/auth";
import {
  getFirestore,
  query,
  getDocs,
  collection,
  where,
  addDoc,
  orderBy
} from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const googleProvider = new GoogleAuthProvider();
const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, "users"), where("uid", "==", user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: user.displayName,
        authProvider: "google",
        email: user.email,
      });
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
const logInWithEmailAndPassword = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err) {
    console.error(err);
    toast.error("Usuario y/o contraseña incorrectos")
  }
};

const logout = () => {
  signOut(auth);
};

const fetchUserName = async (user) => {
  try {
    const q = query(collection(db, "users"), where("uid", "==", user?.uid))
    const doc = await getDocs(q)
    const data = doc.docs[0].data()
    return data
  } catch (err) {
    console.error(err);
  }
};

const getFromDB = async (queryObject) => {
  const {table, order, conditions} = queryObject 
  const collectionRef = collection(db, table);
  const queryData = getQueryData(collectionRef, order, conditions)
  const snapshot = await getDocs(queryData);
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
}

const getQueryData = (collectionRef, order, conditions) => {
  if (conditions !== undefined) {
    const whereRef = where(conditions.field, conditions.operator, conditions.value)
    if (order !== undefined) {
        return query(collectionRef, whereRef, orderBy(order))    
    } else {
      return query(collectionRef, whereRef)
    }
  } else {
    if (order !== undefined) {
      return query(collectionRef, orderBy(order))
    } else {
      return query(collectionRef)
    }
  }
}
export {
  auth,
  db,
  signInWithGoogle,
  logInWithEmailAndPassword,
  logout,
  fetchUserName,
  getFromDB
};